import { BaseModel } from './base';

export class HSEApprovalPerson extends BaseModel {
  subscriberId: string;

  siteId: string;

  approvalpersonId: string;
}
